// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-200 {
    width: 200px;
}

.width-500 {
    width: 500px;
}


@media (width <=424px) {
    .responsive-with {

        width: 250px;
    }
}

@media (424px < width < 600px) {
    .responsive-with {

        width: 300px;
    }
}

@media (width > 600px) {
    .responsive-with {

        width: 500px;
    }
}

.width-450 {
    width: 450px;
}

.font-500 {
    font-weight: 500;
}

.font-600 {
    font-weight: 600;
}

.font-400 {
    font-weight: 400;
}

.font-300 {
    font-weight: 300;
}

.text-blue {
    color: #135fac;
}

.text-white {
    color: white;
}

.text-bright-blue {
    color: #2780d8;
}

.p-25 {
    padding: 25px;
}

.p-10 {
    padding: 10px;
}

.p-5 {
    padding: 5px;
}

.p-l-10 {
    padding-left: 10px;
}

.m-5 {
    margin: 5px;
}

.m-2 {
    margin: 2px;
}

.v-m-2 {
    margin: 2px 0 2px 0;
}

.wide {
    display: flex;
    justify-content: space-between;
}

.bg-blue {
    background-color: #135fac;
}

.bg-form-gray {
    background-color: #ebebeb;
}

.ml-selectable {
    cursor: pointer;
}

.text-v-center {
    height: 1.5em;
    line-height: 1.5em;
}

#selection-list.k-listview {
    border-style: none;
    max-height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/joinable-entity-selector/joinable-entity-selector.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".width-200 {\n    width: 200px;\n}\n\n.width-500 {\n    width: 500px;\n}\n\n\n@media (width <=424px) {\n    .responsive-with {\n\n        width: 250px;\n    }\n}\n\n@media (424px < width < 600px) {\n    .responsive-with {\n\n        width: 300px;\n    }\n}\n\n@media (width > 600px) {\n    .responsive-with {\n\n        width: 500px;\n    }\n}\n\n.width-450 {\n    width: 450px;\n}\n\n.font-500 {\n    font-weight: 500;\n}\n\n.font-600 {\n    font-weight: 600;\n}\n\n.font-400 {\n    font-weight: 400;\n}\n\n.font-300 {\n    font-weight: 300;\n}\n\n.text-blue {\n    color: #135fac;\n}\n\n.text-white {\n    color: white;\n}\n\n.text-bright-blue {\n    color: #2780d8;\n}\n\n.p-25 {\n    padding: 25px;\n}\n\n.p-10 {\n    padding: 10px;\n}\n\n.p-5 {\n    padding: 5px;\n}\n\n.p-l-10 {\n    padding-left: 10px;\n}\n\n.m-5 {\n    margin: 5px;\n}\n\n.m-2 {\n    margin: 2px;\n}\n\n.v-m-2 {\n    margin: 2px 0 2px 0;\n}\n\n.wide {\n    display: flex;\n    justify-content: space-between;\n}\n\n.bg-blue {\n    background-color: #135fac;\n}\n\n.bg-form-gray {\n    background-color: #ebebeb;\n}\n\n.ml-selectable {\n    cursor: pointer;\n}\n\n.text-v-center {\n    height: 1.5em;\n    line-height: 1.5em;\n}\n\n#selection-list.k-listview {\n    border-style: none;\n    max-height: 200px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
